import React from "react";
import SettingsSidebarItem from "./SettingsSidebarItem";
import { Flex, Text } from "@chakra-ui/react";
import { pxToRem } from "../../../utils/styles/size";

const SettingsSidebar = ({
  tabs,
  currentIndex,
  changeItem,
}: {
  currentIndex: number;
  currentItem: { tab: string; content: React.ReactNode };
  changeItem: any;
  tabs: { tab: string; content: React.ReactNode }[];
}) => {
  return (
    <Flex
      direction="column"
      bg="var(--20)"
      width="220px"
      height="100%"
      flexShrink={0}
      padding="54px 20px 0px 20px"
      gap="20px"
      boxSizing="border-box"
      userSelect={"none"}
    >
      <div>
        <Text
          color="white"
          fontSize={pxToRem(16)}
          fontWeight={500}
          fontStyle="normal"
          lineHeight={pxToRem(24)}
          padding="0px 10px"
        >
          Settings
        </Text>
      </div>
      <Flex
        gap={1}
        flexDir={"column"}
      >
        {tabs.map((section, index) => (
          <SettingsSidebarItem
            changeItem={changeItem}
            index={index}
            currentIndex={currentIndex}
            section={section}
          />
        ))}
      </Flex>
    </Flex>
  );
};

export default SettingsSidebar;
